function swymCallbackFn(swat) {
  // your API calls go here
  document.addEventListener('swym:collections-loaded', () => {
    swat.initializeActionButtons('body');
  });
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);
